// extracted by mini-css-extract-plugin
module.exports = {"departments":"sr-z","departmentHeading":"tr-z","departmentSection":"ur-z","departmentName":"vr-z","departmentLink":"wr-z","expandIcon":"xr-z"};